export default "__VITE_ASSET__D67pBExv__"